module.exports = __webpack_public_path__ + "img/certidao-protesto.9ace074b.svg";